import demoHouseLogs from '../../containers/Demo/resource/demo-house-log.data.json'
import demoHouse from '../../containers/Demo/resource/demo-house.json'
import { setMockHandler } from '../../config/init'

// デモ用の三方弁モードバッジ確認データ（加温=hp1Mode:1, 冷却=hp2Mode:0）を注入する
;(demoHouse as { lastLog: Record<string, unknown> }).lastLog = {
	...demoHouse.lastLog,
	createdAt: new Date().toLocaleString(),
	hp1Mode: 1, // 加温
	hp2Mode: 0, // 冷却
}

const demoControlBase = {
	houseId: 0,
	activePin: -1,
	negativePin: -1,
	rate: 0,
	timer: 0,
	cooltime: 0,
	subControls: [] as unknown[],
	activePinView: null,
	negativePinView: null,
	isHit: false,
	lastControl: null,
	createdAt: new Date().toISOString(),
}
const demoTwayControls = [
	{
		...demoControlBase,
		id: 90001,
		label: 'ヒートポンプ1',
		category: 'hp',
		pumpNumber: 1,
	},
	{
		...demoControlBase,
		id: 90002,
		label: '三方弁A（加温デモ）',
		category: 'tway',
		activePin: 0,
		negativePin: 1,
		rate: 60,
		relatedHpId: 90001,
	},
	{
		...demoControlBase,
		id: 90003,
		label: 'ヒートポンプ2',
		category: 'hp',
		pumpNumber: 2,
	},
	{
		...demoControlBase,
		id: 90004,
		label: '三方弁B（冷却デモ）',
		category: 'tway',
		activePin: 2,
		negativePin: 3,
		rate: 40,
		relatedHpId: 90003,
	},
]
if (!demoHouse.controls.some((c) => c.id === 90002)) {
	;(demoHouse.controls as unknown[]).push(...demoTwayControls)
}

export const loadDemoMocks = () => {
	setMockHandler((method, url, _data) => {
		if (method === 'GET' && url === '/houses') {
			return { status: 200, data: [demoHouse] }
		}
		if (method === 'GET' && /\/houses\/0\/logs/.test(url)) {
			return { status: 200, data: demoHouseLogs }
		}
		if (method === 'PUT') {
			alert('[サンプル動作です]変更を実行します。')
			return { status: 200, data: {} }
		}
		if (method === 'POST') {
			alert('[サンプル動作です]作成を実行します。')
			return { status: 200, data: {} }
		}
		if (method === 'DELETE') {
			alert('[サンプル動作です]削除を実行します。')
			return { status: 200, data: {} }
		}
		return null
	})
}
